import React from 'react';
import { connect } from 'react-redux';
import SeriesForm from './SeriesForm';
import { getSeriesById, editSeries } from '../../ducks/workoutActions';

class EditSeries extends React.Component {
  constructor(props) {
    super(props);
    this.workoutId = props.match.params.workoutId;
    this.seriesId = props.match.params.id;
  }

  componentDidMount() {
    this.props.getSeriesById(this.workoutId, this.seriesId, this.props.history);
  }

  render() {
    let { history, currentSeries, editSeries } = this.props;
    if (this.workoutId) {
      return (
        <SeriesForm
          series={currentSeries}
          workoutId={this.workoutId}
          seriesId={this.seriesId}
          history={history}
          handleSubmit={editSeries}
        />
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    currentSeries: state.workoutReducer.currentSeries
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getSeriesById: (workoutId, seriesId, history) => dispatch(getSeriesById(workoutId, seriesId, history)),
    editSeries: (values, workoutId, history) => dispatch(editSeries(values, workoutId, history))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditSeries);
